import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import IconWrap from '@bridebook/ui/src/components/svg/icon-wrap';
import { IStylingProps } from '@bridebook/ui/src/themes/types';
import { TColor } from '@bridebook/ui/src/types';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconBudgetIllustration = ({ id, color, width = 161, style, ...restProps }: IProps) => {
  const viewBoxWidth = 161;
  const viewBoxHeight = 160;

  const icon = ({ width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      width={`${width}px`}
      height={`${height}px`}>
      <circle cx="80.5" cy="80" r="80" fill="#D0F1EB" />
      <circle
        cx="85.0989"
        cy="38.6725"
        r="8.38095"
        transform="rotate(-120 85.0989 38.6725)"
        fill="#FDBD5D"
      />
      <ellipse
        cx="84.2344"
        cy="37.1734"
        rx="8.1724"
        ry="8.38095"
        transform="rotate(-120 84.2344 37.1734)"
        fill="#F9DDB0"
      />
      <path
        d="M59.0256 121.484C58.6548 121.484 57.6353 112.679 57.1719 108.508L69.6844 115.459C69.5299 117.158 69.1282 120.742 68.7575 121.484C68.2941 122.411 59.489 121.484 59.0256 121.484Z"
        fill="#FFCAC5"
      />
      <path
        d="M112.318 121.949C112.689 121.949 113.708 113.143 114.172 108.973L101.659 115.924C101.814 117.623 102.216 121.207 102.586 121.949C103.05 122.875 111.855 121.949 112.318 121.949Z"
        fill="#FFCAC5"
      />
      <path
        d="M48.3704 76.5321C49.3545 72.5957 50.3786 71.5889 51.151 70.0442C50.3786 68.6539 48.4313 65.5926 47.907 64.0196C46.9802 61.239 46.9801 58.1496 46.9802 56.1414C48.6794 55.369 52.912 53.917 56.2487 54.2877C59.5853 54.6584 63.8179 56.9138 65.5172 57.9951C65.9806 56.7593 69.688 54.7512 76.176 53.8243C82.6639 52.8973 88.3248 53.3202 94.2495 54.7511C104.121 57.1352 109.337 59.4649 114.177 64.483C121.262 71.8286 120.665 76.5321 121.592 76.0687C122.519 75.6053 125.299 72.3613 126.226 71.4344C126.967 70.693 128.08 71.1255 128.543 71.4344C129.006 71.7434 129.969 73.3565 129.47 75.1418C128.8 77.5384 126.226 82.1727 123.239 84.9532C123.703 86.8069 124.094 92.8447 121.128 98.7765C118.162 104.708 114.625 110.347 107.225 114.533C100.532 118.32 93.3227 119.167 80.8102 119.167C68.2635 119.167 56.5576 109.281 52.0778 103.874C50.6876 104.029 47.5363 104.245 46.0533 103.874C44.5704 103.503 43.8907 102.175 43.7362 101.557L39.5653 88.1177C39.5653 88.1177 39.1019 85.8006 39.5653 84.4103C40.2784 82.2709 45.2809 80.7029 47.907 80.2395C47.907 79.6216 47.9997 78.0151 48.3704 76.5321Z"
        fill="#FFCAC5"
      />
      <circle cx="60.4265" cy="79.7742" r="2.31713" fill="#546170" />
      <path
        d="M56.4728 108.286C70.372 125.401 114.396 130.161 123.927 91.4279C118.328 103.951 72.8009 116.811 56.4728 108.286Z"
        fill="#FFB8B1"
      />
      <path
        d="M75.9375 62.4733C80.5089 59.4256 86.6042 59.4256 92.6994 62.4732"
        stroke="#546170"
        strokeWidth="1.52381"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconBudgetIllustration;
